module.exports = __webpack_public_path__ + "img/transport_helicopter.2cd1530.png";